import React from 'react';

export const DeleteModal = ({ onSubmit, handleClose }: any) => {
  
  return (
    <div className="fixed inset-0 flex items-center justify-center border-b bg-opacity-50">
      <div className="p-6 m-2 bg-white rounded shadow-lg w-96">
        <div className="cursor-pointer mx-1">
          <svg onClick={handleClose} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-x-circle">
            <circle cx="12" cy="12" r="10" />
            <path d="m15 9-6 6" />
            <path d="m9 9 6 6" />
          </svg>
        </div>
        <div className="my-4 text-center">
          Are you sure you want to delete?
        </div>
        <button
          className="w-full py-2 mt-4 bg-blue-500 text-white rounded"
          onClick={onSubmit}
        >
          Submit
        </button>
      </div>
    </div>
  );
};